function showError(fieldName, message) {
  document.querySelector(`#${fieldName}-error`).textContent = message;
}

function addCreatAccountEventListener() {
  const form = document.getElementById('create_customer');

  form?.addEventListener('submit', (event) => {
    event.preventDefault();

    let isValid = true;
    const terms = document.querySelector('[name="customer[accept_terms]"]');

    if (!terms.checked) {
      isValid = false;
      showError('terms', 'Please accept the terms and conditions');
    }

    if (isValid) {
      form.submit();
    }
  });
}

addCreatAccountEventListener();
